module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "group group--contentful group--sidebar mt2"
  }, [(_vm.articles && _vm.articles.length && !_vm.loadingSearch) ? _c('p', {
    staticClass: "p mb mt50"
  }, [_vm._v(_vm._s(_vm.articles.length) + " " + _vm._s(_vm.articles.length > 1 ? "results" : "result") + " found:")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.articles), function(article) {
    return _c('div', {
      key: article.id
    }, [(article && !_vm.loadingSearch) ? _c('a', {
      staticClass: "link link--accent fw-bold p tdn",
      on: {
        "click": function($event) {
          return _vm.navigateToArticle(article)
        }
      }
    }, [_vm._v("\n      " + _vm._s(article.name) + "\n    ")]) : _vm._e()])
  }), _vm._v(" "), _c('module-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDisclaimer),
      expression: "showDisclaimer"
    }],
    attrs: {
      "modal": _vm.modalExternalData
    },
    on: {
      "close": function($event) {
        _vm.showDisclaimer = false
      }
    }
  }, [_c('template', {
    slot: "modal-footer"
  }, [_c('module-button', {
    nativeOn: {
      "click": function($event) {
        _vm.showDisclaimer = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('module-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.goToUrl.apply(null, arguments)
      }
    }
  }, [_vm._v("Yes")])], 1)], 2), _vm._v(" "), (!_vm.hasResults && !_vm.loadingSearch) ? _c('p', {
    staticClass: "p"
  }, [_vm._v("0 results found - try adjusting your search terms of navigating by topic")]) : _vm._e(), _vm._v(" "), (_vm.loadingSearch) ? _c('module-dots', {
    attrs: {
      "active": true
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8b030894"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/contentful/SearchResults.vue
// module id = 579
// module chunks = 0